<script lang="ts">
import { computed, onMounted } from 'vue';
import { setCookie } from '@/utils/cookies';
import * as crypto from 'crypto-js';

export default { name: 'SessionChecker' };
</script>

<script setup lang="ts">

const hashLink = computed(() => {
  const now = new Date();
  const date_str = (`0${now.getDate()}`).slice(-2) + (`0${now.getMonth() + 1}`).slice(-2) + now.getFullYear();
  const hash = crypto.SHA1(`dev.ecohospital.ru${date_str}`);
  const digestHex = hash.toString(crypto.enc.Hex);
  return digestHex;
});

onMounted(() => {
  console.log('Redirecting to ESIA with hash:', hashLink.value);
  window.open(
    `https://esia.medsafe.tech/${hashLink.value}`,
    '_self',
  );
  setCookie('dev-eco-hash', hashLink.value, { secure: true, expires: 1 });
});
</script>
